import {cs}                              from "@Common/react/chain-services";
import {consumeContext, provideContext1} from "@Common/react/context";
import {RCache}                          from "@Common/react/r-cache";

export const loadTemplateOptionsCache = (next) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    ["cache", ({apis, session}, next) => RCache({
        serializeKey: (sku) => {
            if (!sku) {
                return JSON.stringify(sku);
            }
            if (sku.front) {
                sku.front = +sku.front;
            }
            if (sku.back) {
                sku.back = +sku.back;
            }
            return JSON.stringify(sku);
        },
        _key: JSON.stringify(session.value),
        load: (sku) => !sku ? null : apis.next.getTemplateOptions(sku),
        maxSize: 30,
        next,
    })],
    ({cache}) => provideContext1("templateOptionsCache", cache, next),
);
